import React from "react"
import { Menu, MenuButton, MenuList, MenuLink } from "@reach/menu-button"
import Icon from "components/planning_center_icon"
import pcoURL from "@planningcenter/url"
import PropTypes from "prop-types"
import axios from "axios"

export default function StaffActionsDropdown({ personAcid }) {
  const ccwImpersonationUrl = `${pcoURL(window.railsEnv)(
    "accounts"
  )}/staff/church_center_impersonations/new?person_id=${personAcid}`

  return (
    <Menu className="staff-only">
      <MenuButton className="ml-1 app-btn action-dropdown-btn btn2 staff-only staff-only-dropdown">
        Staff Actions
        <span data-reach-menu-button-toggle-icon className="ml-1">
          <Icon symbol="general#down-caret" />
        </span>
      </MenuButton>
      <MenuList>
        <MenuLink
          href={ccwImpersonationUrl}
          className="dropdown-menu-item staff-only staff-only-dropdown-menu-item"
        >
          Impersonate on CCW
        </MenuLink>
        <button
          id="resync"
          className="dropdown-menu-item staff-only staff-only-dropdown-menu-item w-100%"
          onClick={() => {
            axios
              .get(`${`${pcoURL(window.railsEnv)("registrations")}/people/AC${personAcid}`}/resync`)
              .then(() => Turbolinks.visit())
          }}
        >
          Force Account Center Re-Sync
        </button>
        <button
          id="resync"
          className="dropdown-menu-item w-100% staff-only staff-only-dropdown-menu-item"
          onClick={() => {
            axios
              .post(
                `${pcoURL(window.railsEnv)("registrations")}/staff/my_church_center_syncs`,
                {
                  person_acid: personAcid
                },
                {
                  withCredentials: true,
                  headers: {
                    "X-CSRF-Token": $.rails.csrfToken()
                  }
                }
              )
              .then(() =>
                alertModal(
                  {
                    title: "My Church Center sync!",
                    text: `All Registrations MCC activities for this person have been deleted and re-synced`,
                    type: "success",
                    confirmButtonText: "Ok",
                    customClass: "success",
                    closeOnConfirm: true
                  },
                  () => {
                    Turbolinks.visit()
                  }
                )
              )
          }}
        >
          Force My Church Center Re-Sync
        </button>
      </MenuList>
    </Menu>
  )
}

StaffActionsDropdown.propTypes = {
  personAcid: PropTypes.number
}
